import { forwardRef } from 'react';
import { TextField } from '@mui/material';

const phoneInput = (props, ref) => (
  <TextField {...props} inputRef={ref} fullWidth size="small" label="Phone Number" variant="outlined" />
);
export default forwardRef(phoneInput);
